module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"notRecorded":"Видеозвонок завершен, но запись не производилась"}}')
  delete Component.options._Ctor
}
